<template>
  <div>
    <div>
      <v-app-bar app color="primary" class="mb-0 pb-0" dark>
        <v-btn dark icon @click="back()">
          <v-icon dense x-large>mdi-chevron-left</v-icon>
        </v-btn>

        <v-toolbar-title>
          {{
          $route.params.category
          ? $route.params.category
          : renderProductCategory()
          }}
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <!--        <v-btn-->
        <!--          icon-->
        <!--          @click="-->
        <!--          $router.push({-->
        <!--            name: 'cart',-->
        <!--            query: { unix: Date.now().toString() }-->
        <!--          })-->
        <!--        "-->
        <!--        >-->
        <!--          <v-icon>mdi-cart</v-icon>-->
        <!--        </v-btn>-->
      </v-app-bar>
      <v-subheader
        class="grey lighten-3 body-1 font-weight-bolder"
        style="height: 40px !important"
      >Produtos</v-subheader>
    </div>
    <v-list three-line v-if="products.length > 0 && !loading" class="pt-0">
      <template v-for="(item, index) in products">
        <v-divider :key="index"></v-divider>
        <v-list-item
          :key="item.title"
          :disabled="item.pdv.availability === 'UNAVAILABLE'"
          @click="$router.push({ name: item.isCombo ? 'product-combo':'product', params: { product: item, id: item.id } })"
        >
          <v-list-item-content class="d-flex align-start">
            <v-list-item-title
              v-text="item.name"
              class="pb-0 overflow-subtitle wrap-text"
              style="height: auto !important;"
            />
            <v-list-item-subtitle
              class="overflow-subtitle"
              :style="
                item.pdv.availability === 'UNAVAILABLE'
                  ? 'color: rgba(0, 0, 0, 0.38);'
                  : ''
              "
              v-html="item.description"
            ></v-list-item-subtitle>
            <v-list-item-action-text v-if="notOnlyDigitalMenu()" v-html="item.pdv.availabilityHTML"></v-list-item-action-text>
          </v-list-item-content>
          <v-list-item-action class="mt-2 mb-1">
            <v-avatar size="60">
              <v-img
                :style="
                  item.pdv.availability === 'UNAVAILABLE'
                    ? 'opacity: 0.38;'
                    : ''
                "
                :src="item.image"
              ></v-img>
            </v-avatar>
            <span class="subheading mt-1" style="color: green;">
              {{item.isCombo ? "A partir de " : "" }}{{
               $toBrl(parseInt(item.price, 10))
              }}
            </span>
          </v-list-item-action>
        </v-list-item>
      </template>
    </v-list>
    <div v-else-if="loading">
      <template v-for="i in 4">
        <div :key="`loader-${i}`">
          <v-layout row class="pl-5 pr-5 pt-1 pb-1">
            <v-flex xs9 class="pt-3">
              <v-skeleton-loader type="text" />
              <v-skeleton-loader type="text" />
            </v-flex>
            <v-flex xs3 class="d-flex justify-end align-center">
              <v-skeleton-loader type="avatar" width="60" />
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
        </div>
      </template>
    </div>
    <v-sheet v-else class="fill-height d-flex align-center justify-center">
      <span class="subtitle-1">Por enquanto, não há nada aqui</span>
    </v-sheet>
  </div>
</template>

<script>
import ProductService from "../services/productService";

export default {
  data() {
    return {
      products: [],
      loading: false
    };
  },
  beforeDestroy () {
    document.removeEventListener("backbutton", this.yourCallBackFunction);
  },
  async mounted() {
    document.addEventListener("backbutton", this.yourCallBackFunction, false);
    if (!this.$route.params.id) {
      await this.$router.push({ name: "categories" });
      return;
    }
    this.loading = true;
    const res = await new ProductService().getProducts(
      {},
      this.$route.params.id
    );
    const res2 = await new ProductService().getProductsCombos(
        {},
        this.$route.params.id
    );
    this.loading = false;
    this.products = [];

    res.data.products.forEach(product => {
      if (!product.availability) {

        if(product.pdvs.length === 0) return
        product.pdvs.forEach(productPDV => {
          const p = JSON.parse(JSON.stringify(product));
          p.pdv = productPDV;

          let sub = ``;


         

          const accessPoint = JSON.parse(localStorage.getItem("accessPoint"));
      
       
          const configuration = accessPoint.configurations.filter(
            configuration =>
              configuration.pdvs.filter(pdv => productPDV.id === pdv.id).length > 0
          )[0];

        
          if (configuration && configuration.availability)
            p.pdv.availability = configuration.availability;
          if (p.pdv.availability === "UNAVAILABLE")
            sub += `<span style="width: calc(100% - 74px); color: rgba(0, 0, 0, 0.38)">Indisponível no ${p.pdv.name}!</span>`;
          else if (p.pdv.availability === "NODELIVERY")
            sub += `<span style="width: calc(100% - 74px);  color: orange"> Retirada no ${p.pdv.name}*</span>`;
          else if (p.pdv.availability === "DELIVERY")
            sub += `<span style="width: calc(100% - 74px);color: black">Entregue pelo ${p.pdv.name}</span>`;
          else return;

          if(!p) {
            this.products = []
          }
          if(p) {
            p.originalPrice = p.price;
            this.products.push(p);
            sub += "</div>";
            p.pdv.availabilityHTML = sub;
          }
         
          
        });
      }
    });

    res2.data.products.forEach(product => {
      if (!product.availability) {
        if(product.pdvs.length === 0) return
        product.pdvs.forEach(productPDV => {
          const p = JSON.parse(JSON.stringify(product));
          p.pdv = productPDV;

          let sub = ``;

      
         
          const accessPoint = JSON.parse(localStorage.getItem("accessPoint"));

         
          const configuration = accessPoint.configurations.filter(
              configuration =>
                  configuration.pdvs.filter(pdv => productPDV.id === pdv.id)
                      .length > 0
          )[0];

          if (configuration && configuration.availability)
            p.pdv.availability = configuration.availability;
          if (p.pdv.availability === "UNAVAILABLE")
            sub += `<span style="width: calc(100% - 74px); color: rgba(0, 0, 0, 0.38)">Indisponível no ${p.pdv.name}!</span>`;
          else if (p.pdv.availability === "NODELIVERY")
            sub += `<span style="width: calc(100% - 74px);  color: orange"> Retirada no ${p.pdv.name}*</span>`;
          else if (p.pdv.availability === "DELIVERY")
            sub += `<span style="width: calc(100% - 74px);color: black">Entregue pelo ${p.pdv.name}</span>`;
          else return;


          if(!p) {
            this.products = []
          }
          if(p) {
            p.originalPrice = p.price;
            p.isCombo = true;
            this.products.push(p);
            sub += "</div>";
            p.pdv.availabilityHTML = sub;
          }
         
    
        });
      }
    });
  },

 
  
  methods: {
    back() {
      
      this.$router.go(-1);
    },
    yourCallBackFunction () {
      
    },
    renderProductCategory() {
      if (this.products.length > 0) {
        const category = this.products[0].categories.filter(
          category => category.id === parseInt(this.$route.params.id)
        )[0];
        if (category) {
          return category.name;
        }
        return "Produtos";
      }
    },
    notOnlyDigitalMenu() {
      if(!localStorage.getItem("onlyDigitalMeny")) return false;
      return localStorage.getItem("onlyDigitalMenu").toString() !== "true";
    }
  }
};
</script>

<style scoped>
.v-list-item__title {
  white-space: normal !important;
}
</style>
